import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';

import { FatPendingCommitmentsPageAllocationAssigneesQuery } from '@/__generated__/graphql';
import ModalWrappedContent from '@/components/basicComponents/modal/modalWrappedContent';
import Select from '@/components/basicComponents/select';
import { createSimpleSelectOption } from '@/components/basicComponents/select/utils';
import { ASSIGNEE_QUERY } from '../queries';
import { IRowData } from '../types';

interface AssignTaskProps {
  onClose: () => void;
  updateAllocationAssignee: (variables: any) => void;
  isOpen: boolean;
  allocation: IRowData | null;
  refetch: any;
}

const AssignTask = ({ isOpen, onClose, updateAllocationAssignee, allocation, refetch }: AssignTaskProps) => {
  const [assignees, setAssignees] = useState([]);
  const [select, setSelect] = useState(`${allocation?.assignee?.firstName ?? ''} ${allocation?.assignee?.lastName ?? ''}`);

  const { data } = useQuery(ASSIGNEE_QUERY, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'no-cache',
    variables: {
      id: allocation?.id
    }
  });

  const assignTask = () => {
    const newAssignee = data.AllocationAssignees.find(
      (assignee: FatPendingCommitmentsPageAllocationAssigneesQuery['AllocationAssignees'][number]) =>
        `${assignee.firstName} ${assignee.lastName}` === select
    );
    updateAllocationAssignee({
      variables: {
        data: {
          id: allocation.id,
          assigneeUserId: newAssignee.id
        }
      }
    });
    onClose();
  };
  useEffect(() => {
    if (data?.AllocationAssignees) {
      setAssignees(
        data.AllocationAssignees.map(
          (user: FatPendingCommitmentsPageAllocationAssigneesQuery['AllocationAssignees'][number]) => `${user.firstName} ${user.lastName}`
        )
      );
    }
  }, [data]);

  if (!allocation) return <></>;

  return (
    <ModalWrappedContent
      isOpen={isOpen}
      onClose={onClose}
      title={'Assign Task'}
      confirmButton={{ name: 'Assign', onClick: assignTask, disabled: !assignees?.length }}
      showRequiredFields
    >
      <Select
        value={select}
        setValue={(value) => setSelect(value)}
        options={assignees?.map((assignee) => createSimpleSelectOption(assignee)) || []}
        styleType={!assignees?.length ? 'disabled' : 'default'}
        label="Select An Assignee"
        size="md"
        isRequiredField
      />
    </ModalWrappedContent>
  );
};

export default AssignTask;
